export enum PRODUCT_KIND {
  KIND1 = 'kind1', // Current Account
  KIND2 = 'kind2', // Savings Account
  KIND4 = 'kind4', // Credit Card
  KIND5 = 'kind5', // Loan
  KIND6 = 'kind6', // Term Deposit
}
